/**
 * @generated SignedSource<<e8c43a9bbaf415c25634130b20132f9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PreviewSendMessageEmailInput = {
  occurrenceId?: string | null;
  organizationId?: string | null;
  productId?: string | null;
  richEditorBody: string;
  subject: string;
};
export type MessageCommunityMembersFormPreview_EmailMutation$variables = {
  input: PreviewSendMessageEmailInput;
};
export type MessageCommunityMembersFormPreview_EmailMutation$data = {
  readonly response: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type MessageCommunityMembersFormPreview_EmailMutation = {
  response: MessageCommunityMembersFormPreview_EmailMutation$data;
  variables: MessageCommunityMembersFormPreview_EmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PreviewSendMessageEmailResponse",
    "kind": "LinkedField",
    "name": "previewSendMessageEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageCommunityMembersFormPreview_EmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageCommunityMembersFormPreview_EmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0135269879edcc41f16b698ba3ef382",
    "id": null,
    "metadata": {},
    "name": "MessageCommunityMembersFormPreview_EmailMutation",
    "operationKind": "mutation",
    "text": "mutation MessageCommunityMembersFormPreview_EmailMutation(\n  $input: PreviewSendMessageEmailInput!\n) {\n  response: previewSendMessageEmail(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dce5c8bd8f12c5ad0636f012a2c3743";

export default node;
